module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/thankyou-508925c80e224e6b7a69ca3fe704b70e.jpeg";